import encodeChars from './encodeChars';
import decodeChars from './decodeChars';

export default {
  encode(data, {name}) {
    const key = encodeChars.colon(name);
    const val = Object.entries(data.value)
      .map(([valKey, str]) =>
        (key === str ? encodeChars.spaces(str) : encodeChars.spaces(`${valKey}.${str}`)))
      .join('_');

    return [key, val];
  },
  decode(value, {settings}) {
    const originalText = decodeChars.spaces(value);
    const arr = originalText.split('.');
    return {
      paramName: settings.autocomplete.get_param,
      type: settings.type,
      value: arr.length > 1 ? {[arr[0]]: arr[1]} : {[originalText]: originalText},
    };
  },
};
